import { render, staticRenderFns } from "./time.vue?vue&type=template&id=5be6426c&scoped=true&"
import script from "./time.ts?vue&type=script&lang=ts&"
export * from "./time.ts?vue&type=script&lang=ts&"
import style0 from "./time.scss?vue&type=style&index=0&id=5be6426c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be6426c",
  null
  
)

export default component.exports